import he from "he";
import { LANGUAGES } from "../constants/language";
import { setCurrentUserInLocalStorage, setI18nLanguageInLocalStorage } from '../helpers/localStorageHelper';
import { AuthenticationService } from "../services/authService";
import { postChangeLanguage } from "../services/userService";
import { i18n, initializeI18n } from "./i18n";

const safeTranslate = async (key, options = {}, namespace = null, errorFallback = "") => {
  if (!i18n.isInitialized) {
    await initializeI18n();
  }
  const namespacedKey = namespace ? `${namespace}:${key}` : key;
  const translation = i18n.t(namespacedKey, options);
  if (translation === namespacedKey || translation === key) {
    return errorFallback.length ? errorFallback : key;
  }
  return he.decode(translation);
};

export const translate = async (key, commonNamespace = false, errorFallback = "") => {
  const namespace = commonNamespace ? "common_ns" : null;
  return safeTranslate(key, {}, namespace, errorFallback);
};

export const translateWithParams = async (key, params, commonNamespace = false) => {
  const namespace = commonNamespace ? "common_ns" : null;
  return safeTranslate(key, params, namespace);
};

export const translateAll = async (keys = [], commonNamespace = false) => {
  const namespace = commonNamespace ? "common_ns" : null;
  return Promise.all(keys.map((key) => safeTranslate(key, {}, namespace)));
};

export const translateKeyValue = async (elements = {}) => {
  const result = { ...elements };
  for (const key of Object.keys(result)) {
    result[key] = await safeTranslate(result[key]);
  }
  return result;
};

export const changeLanguageByUser = async (languageCode) => {
  if (!i18n.isInitialized) {
    await initializeI18n();
  }

  const user = AuthenticationService.instance().getCurrentUser();
  if (user) {
    user.defaultLanguage = languageCode;

    setCurrentUserInLocalStorage(user);
    await postChangeLanguage({ language: languageCode });
  }

  if (i18n.language !== languageCode) {
    i18n.changeLanguage(languageCode).then(() => {
      setI18nLanguageInLocalStorage(languageCode);
      const segments = window.location.pathname.split("/").filter(Boolean);
      if (LANGUAGES.includes(segments[0])) {
        segments[0] = languageCode;
      } else {
        segments.unshift(languageCode);
      }
      const newUrl = `/${segments.join("/")}${window.location.search}`;
      window.location.href = newUrl;
    });
  }
};
